/**
 * Waits for Adobe Launch (_satellite) to be loaded and ready
 * @param timeout Maximum time to wait in milliseconds (default: 5000ms)
 * @returns Promise that resolves to true if Adobe Launch loaded, false if timeout
 */
export const waitForAdobeAnalytics = (timeout = 5000): Promise<boolean> => {
  return new Promise((resolve) => {
    // Check if _satellite (Adobe Launch) is already loaded
    // eslint-disable-next-line no-underscore-dangle
    if (typeof (window as any)._satellite !== 'undefined') {
      resolve(true);
      return;
    }

    // Poll for _satellite to be loaded
    const checkInterval = setInterval(() => {
      // eslint-disable-next-line no-underscore-dangle
      if (typeof (window as any)._satellite !== 'undefined') {
        clearInterval(checkInterval);
        resolve(true);
      }
    }, 100);

    // Timeout after specified duration
    setTimeout(() => {
      clearInterval(checkInterval);
      resolve(false);
    }, timeout);
  });
};
